module.exports = __webpack_public_path__ + "static/media/ethiopian_chamber_of_commerce.ebe60f20.jpg";